import { PipeTransform } from '@angular/core';
var SimpleMdPipe = /** @class */ (function () {
    function SimpleMdPipe() {
    }
    SimpleMdPipe.prototype.transform = function (value) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        if (!value || typeof value !== 'string') {
            return '';
        }
        var replaceStr = args.length && args[0] === 'plaintext' ? '$1$2$3' : '$1<em>$2</em>$3';
        return value.replace(/(^|\W)_((?=[^\W_]).*?[^\W_])_($|\W)/g, replaceStr);
    };
    return SimpleMdPipe;
}());
export { SimpleMdPipe };
